import { useQuery } from "@tanstack/react-query";
import { Navigate, useNavigate, useSearchParams } from "react-router";

import { NewBusinessForm } from "@/components/business/NewBusinessForm";
import { MAIN_CONTENT_ID, SkipLink } from "@/components/layout/SkipLink";
import { FullPageSpinner } from "@/components/ui";
import { identity } from "@/lib/api";

/**
 * First run: every website belongs to a business (an Identity organization), so a new account
 * starts here with the "Add a new business" card. Anyone who already has one adds more from the
 * header's business switcher, which opens the same form as a popup over the portal — old
 * `/onboarding?new=1` links are sent there.
 */
export function OnboardingPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orgs = useQuery({ queryKey: ["organizations"], queryFn: identity.organizations });

  if (orgs.isPending) return <FullPageSpinner />;
  if ((orgs.data?.items.length ?? 0) > 0)
    return <Navigate to={params.get("new") === "1" ? "/?new-business" : "/"} replace />;

  return (
    <div className="flex min-h-full items-center justify-center bg-canvas px-4 py-12">
      <SkipLink />
      <main
        id={MAIN_CONTENT_ID}
        tabIndex={-1}
        className="w-full max-w-[560px] rounded-[28px] bg-surface p-6 drop-shadow-[0px_16px_20px_rgba(13,8,5,0.12)] sm:p-12"
      >
        <NewBusinessForm title="Add your business" onCreated={() => navigate("/", { replace: true })} />
      </main>
    </div>
  );
}
